import React from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  DialogActions,
  TextField,
  Typography,
  Box,
} from '@mui/material';
import { policies, selectItems } from '../../data/userSettings';
import PolicyList from './PolicyList';
import { useGlobalContext } from '../../context/GlobalStore';
import { styles } from './styles';
import MultiSelectChip from './MultiSelectChip';
import Loading from '../../mui-components/Loading';

const CreateUserModal = (props) => {
  const {
    open,
    handleClose,
    handleCreateUser,
    newUser,
    setNewUser,
    isLoading,
  } = props;
  const { state } = useGlobalContext();
  const inputItems = [
    { label: 'Name', name: 'name', type: 'text' },
    { label: 'Email', name: 'email', type: 'email' },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewUser((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      onSubmit={handleCreateUser}
      component="form"
    >
      {isLoading ? (
        <DialogContent sx={styles.loadingBox}>
          <Loading />
        </DialogContent>
      ) : (
        <>
          <DialogTitle id="alert-dialog-title">{'Create User'}</DialogTitle>
          <DialogContent sx={styles.contentBox}>
            {inputItems.map((item) => {
              return (
                <Box
                  display="flex"
                  alignItems="center"
                  key={`input-${item.name}`}
                >
                  <Typography sx={styles.label} variant="body1">
                    {item.label}:
                  </Typography>
                  <TextField
                    name={item.name}
                    size="small"
                    sx={styles.input}
                    type={item.type}
                    onChange={handleChange}
                    required
                  />
                </Box>
              );
            })}
            {selectItems.map((item) => {
              return (
                <Box key={`select-${item.name}`}>
                  <Box display="flex" alignItems="center">
                    <Typography variant="body1" sx={styles.label}>
                      {item.label}:
                    </Typography>
                    <MultiSelectChip
                      user={newUser}
                      handleChange={handleChange}
                      item={item}
                    />
                  </Box>
                </Box>
              );
            })}
          </DialogContent>
          <DialogActions sx={{ padding: 3 }}>
            <Button onClick={handleClose} variant="outlined">
              Cancel
            </Button>
            <Button variant="contained" type="submit" autoFocus>
              Create
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default CreateUserModal;
